/**
 * Quick-add — single-variant product cards POST directly to /cart/add and
 * open the cart drawer. Multi-variant cards just link to the PDP (the
 * Liquid handles that branch; this script only binds the single-variant
 * `[data-quick-add]` buttons).
 *
 * Document-delegated so newly-rendered cards (search, AJAX filter,
 * recently-viewed strip) work without extra wiring.
 */
(() => {
  if (window.__quickAddBound) return;
  window.__quickAddBound = true;

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    const label = btn.querySelector('[data-quick-add-label]');
    const originalLabel = label?.textContent;

    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    if (label) label.textContent = 'Adding…';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || err.message || 'Add to cart failed');
      }

      const cart = await fetch('/cart.js').then((r) => r.json());
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      document.dispatchEvent(new CustomEvent('cart:open'));

      if (label) label.textContent = 'Added';
      setTimeout(() => { if (label) label.textContent = originalLabel; }, 1400);
    } catch (err) {
      console.error('[quick-add]', err);
      if (label) label.textContent = 'Try again';
      setTimeout(() => { if (label) label.textContent = originalLabel; }, 1800);
    } finally {
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
    }
  });
})();
